import { render, staticRenderFns } from "./ProductsCategoryInput.vue?vue&type=template&id=7c31dd95&"
import script from "./ProductsCategoryInput.vue?vue&type=script&lang=js&"
export * from "./ProductsCategoryInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports